import { useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import PermissionModal from '../PermissionModal';
import userService from '../../../../services/userService';
import { removeUserFromTeam } from '../../../../services/teamService';

import './TeamMembers.scss';

const Members = ({ team, currentUser, onRemoveUser }) => {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUserClick = async (user) => {
    try {
      const { data: userData } = await userService.getUser(user._id);

      setSelectedUser(userData);
      setIsModalOpen(true);
    } catch (error) {
      toast.error(t('team.userLoadFailed'));
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handleRemoveUser = async (userId) => {
    try {
      await removeUserFromTeam(team._id, userId);
      toast.success(t('team.removed'));
      handleCloseModal();
      onRemoveUser(userId);
    } catch (error) {
      toast.error(t('team.removeFailed'));
    }
  };

  const handleToggleSuggestSongs = async (userId) => {
    try {
      const currentState = selectedUser?.permissions?.canSuggestSongs || false;

      const { data: updatedUserData } = await userService.updateUserPermissions(userId, {
        canSuggestSongs: !currentState,
      });

      // Update the selectedUser with the returned data
      setSelectedUser(updatedUserData);
    } catch (error) {
      toast.error(t('team.permissionFailed'));
    }
  };

  const renderUserPill = (user) => {
    const isAdmin = currentUser && currentUser.isAdmin;

    if (isAdmin) {
      const isAdminPill = (user) => currentUser._id === user._id;

      return (
        <span
          key={user._id}
          className={`member ${!isAdminPill(user) ? 'member--clickable' : ''}`}
          onClick={!isAdminPill(user) ? () => handleUserClick(user) : undefined}
        >
          {formatName(user.name)}
          {isAdminPill(user) && <span className="you">{t('team.you')}</span>}
        </span>
      );
    } else {
      return (
        <span key={user._id} className="member">
          {formatName(user.name)}
          {currentUser && currentUser._id === user._id && <span className="you">{t('team.you')}</span>}
        </span>
      );
    }
  };

  return (
    <>
      <div className="TeamMembers">
        <p className="count">{team.users && t('team.members', { count: team.users.length })}</p>
        <div className="members">{team.users && team.users.map((user) => renderUserPill(user))}</div>
      </div>

      <PermissionModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        user={selectedUser}
        team={team}
        onRemoveUser={handleRemoveUser}
        onToggleSuggestSongs={handleToggleSuggestSongs}
      />
    </>
  );
};

const formatName = (name) => {
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

export default Members;
